import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Container, Grid } from "@material-ui/core";
import {
  SimpleLoading,
  ButtonAddHLPure,
  ButtonHLPure,
  DialogSystemGLPure,
  DialogContractor,
} from "../../pures";
import {
  HeaderHLPure,
  CheckBoxHLPure,
  InputHLPure,
  DialogYesNoHLPure,
  GridHLPure,
  DialogFormHLPure,
  SearchBarHLPure,
} from "../../pures";
import "./request-for-contract.css";
import { NIL } from "uuid";
import { arrObjNoRepetElements } from "../../../utils";
import { LocalStorageService } from "../../../services";

const RequestForContractPanelView = (props) => {
  //Variables for DatePicker
  const { contractRequest, token, questionnaire, contractorsType, companies, changeRoute } =
    props;
  const today = new Date();
  let limitMaxDate = new Date();
  limitMaxDate.setDate(limitMaxDate.getDate() + 61);
  //Declaration and initilization for variables to the view, grid, and dialogs
  const { contractors, email } = props;
  const [dataItemUser, setDataItemUser] = useState({});
  const { t } = useTranslation();
  const [errorInDocumentName, setErrorInDocumentName] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [nameComponentUser, setNameComponentUser] = useState("");
  const [selectedUser, setSelectedUser] = useState({});
  const [toggleDialogForm, setDialogForm] = useState(false);
  //Dialog Inputs and Declarations
  const [toggleErrorInDate, setToggleErrorInDate] = useState(false);
  const [toggleNewContractorDialog, setToggleNewContractorDialog] =
    useState(false);
  const [errorInEmail, setErrorInEmail] = useState(false);
  const [newContractorName, setNewContractorName] = useState("");
  const [newContractorEmail, setNewContractorEmail] = useState("");
  const [newContractorNotes, setNewContractorNotes] = useState("");
  const [newContractLimitDate, setNewContractLimitDate] = useState(today);
  const [errorInContractorName, setErrorInContractorName] = useState(false);
  const [documentRequestName, setDocumentRequestName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [itselfRegister, setItselfRegister] = useState(false);
  const [showDialogYesNo, setShowDialogYesNo] = useState(false);
  //First view declarations and variables
  const [contractorsState, setContractorsState] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [previousFilteredState, setPreviousFilteredState] = useState([]);
  const [searchUpdateState, setSearchUpdateState] = useState([]);
  const [previousContractorsState, setContractorsPreviousState] = useState([]);
  const [contractorsFinal, setContractorsFinal] = useState([]);
  const [contractorsFiltered, setContractorsFiltered] = useState([]);
  const [headerTitleinDetail, setHeaderTitleinDetail] = useState({
    clicked: false,
    name: "",
  });
  const [showWarningRequesting, setShowWarningRequesting] = useState(false);
  const [showErrorRequesting, setShowErrorRequesting] = useState(false);
  const [showLoadingRequesting, setShowLoadingRequesting] = useState(false);
  const [showCompletedRequesting, setShowCompletedRequesting] = useState(false);
  const [savedIdContractor, setSavedIdContractor] = useState();
  const [dataContract, setDataContract] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const [contractorType, setContractorType] = useState(7);
  const [companySelectedDialog, setCompanySelectedDialog] = useState("");

  const history = useHistory();

  const handleChangeDocumentRequestName = (e) => {
    setDocumentRequestName(e.target.value);
  };

  const handleChangeContractrorName = (e) => {
    setNewContractorName(e.target.value);
  };

  const handleChangeContractrorEmail = (e) => {
    setNewContractorEmail(e.target.value);
  };

  const handleChangeContractrorNotes = (e) => {
    setNewContractorNotes(e.target.value);
  };

  const handleChangeLimitDate = (e) => {
    let todayDate = new Date();
    let eventDate = new Date(e.target.value);

    eventDate.setHours(0, 0, 0, 0);
    todayDate.setHours(0, 0, 0, 0);

    if (
      eventDate < todayDate ||
      eventDate > limitMaxDate ||
      eventDate === null
    ) {
      setToggleErrorInDate(true);
      setNewContractLimitDate(today);
    } else if (eventDate >= todayDate || eventDate <= limitMaxDate) {
      setToggleErrorInDate(false);
      setNewContractLimitDate(e.target.value);
    }
  };

  const handleItselfRegister = (e) => {
    setItselfRegister(e.target.checked);
    if (e.target.checked) {
      setNewContractorEmail(email);
    } else {
      setNewContractorEmail("");
    }
  };

  const cleanContractorSolitude = () => {
    setNewContractorName("");
    setNewContractorEmail("");
    setNewContractorNotes("");
  };

  useEffect(() => {
    setSearchUpdateState(contractors ? [...contractors] : []);
    setContractorsPreviousState(contractors ? [...contractors] : []);
    setContractorsState(contractors ? contractors : []);
  }, [contractors]);

  useEffect(() => {
    //If questionnaire has assigned a company filter contractors by companyId
    if (!questionnaire || !contractors) return;
    let companyContractor = [];
    if (questionnaire.companyId !== NIL) {
      let copyContractors = [...contractors];
      copyContractors.map((contractor) => {
        if (contractor.company) {
          let company = contractor.company.find(
            (company) => company.id === questionnaire.companyId
          );
          if (company) {
            companyContractor.push(contractor);
          }
        }
        return contractor;
      });
      let contractorsFilter = arrObjNoRepetElements(companyContractor, "id");
      setSearchUpdateState(contractorsFilter);
      setContractorsPreviousState(contractorsFilter);
      setContractorsState(contractorsFilter);
    }
  }, [questionnaire, contractors]);

  useEffect(() => {
    if (!questionnaire || !companies || companies.length === 0) return;
    if (questionnaire.companyId !== NIL) {
      setCompanySelectedDialog(questionnaire.companyId);
    } else {
      setCompanySelectedDialog(companies[0].id);
    }
  }, [questionnaire, companies]);

  const validateContractName = async () => {
    try {
      if (documentRequestName != "") {
        setShowLoadingRequesting(true);
        // let contractorsSend = contractorsFiltered.filter(
        //   (contractor) => contractor.id && contractor.notifyBtn === true
        // );
        let localStorageService = new LocalStorageService()
        let timezone = localStorageService.getLocalStorageItem("timezone");

        const body = {
          name: documentRequestName,
          description: questionnaire.description,
          questionnaireId: questionnaire.id,
          clientContractStatusId: 1,
          userCreatorEmail: email,
          userLawyerId: "",
          contractorList: contractorsFiltered,
          existClientContract: savedIdContractor,
          timezone
        };
        let response = await contractRequest.createClientContractContractors(
          body,
          token
        );
        if (response.data.statusCode === 200) {
          setShowLoadingRequesting(false);
          setShowCompletedRequesting(true);

          setTimeout(() => {
            setShowCompletedRequesting(false);
            setErrorInDocumentName(false);
            history.push({
              pathname: `/followup-actions-contracts/${response.data.data.id}/${response.data.data.workflowExecutionId}`,
              state: response?.data?.data,
            });
          }, 3000);
        } else if (response.data.statusCode === 440) {
          setErrorMessage(t('requestForContract.error.questionnaireWithoutTemplate'))
          setShowLoadingRequesting(false)
          setShowErrorRequesting(true)
          setTimeout(() => {
            setShowErrorRequesting(false)
          }, 4000)
        } else {
          setShowLoadingRequesting(false);
          setShowErrorRequesting(true);

          setTimeout(() => {
            setShowErrorRequesting(false);
          }, 3000);
        }
      } else {
        setErrorInDocumentName(true);
        setTimeout(() => {
          setErrorInDocumentName(false)
        }, 3000)
      }
    } catch (e) {
      setShowLoadingRequesting(false);
      setShowErrorRequesting(true);
      setTimeout(() => {
        setShowErrorRequesting(false);
      }, 3000);
    }
  };

  const createContractor = async () => {
    let emailRegex =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    try {
      if (documentRequestName != "") {
        if (!newContractorName) {
          setErrorInContractorName(true);
          setTimeout(() => setErrorInContractorName(false), 3000);
          return;
        }
        if (newContractorEmail.match(emailRegex)) {
          let localStorageService = new LocalStorageService()
          let timezone = localStorageService.getLocalStorageItem("timezone");

          const body = {
            email: newContractorEmail,
            emailCreator: email,
            name: newContractorName,
            nameContract: documentRequestName,
            limitDate: newContractLimitDate,
            notes: newContractorNotes,
            description: newContractorNotes,
            questionnaireId: questionnaire.id,
            clientContractStatusId: null,
            userLawyerId: null,
            contractCreatedId: null,
            isRepse: false,
            onlyCreateContractor: false,
            companyId: companySelectedDialog,
            classifierId: 1,
            contractorPersonType: contractorType,
            timezone
          };
          closeContractorDialog();
          setShowLoadingRequesting(true);
          let response = await contractRequest.createContractor(body, token);
          if (response.data.statusCode === 200) {
            setShowLoadingRequesting(false);
            setShowCompletedRequesting(true);
            let copyContractors = [...contractorsFinal];
            let newContractor = response.data.data.contractor
            newContractor.notifyBtn = true
            copyContractors.push(newContractor)
            setContractorsFiltered(copyContractors);
            setContractorsFinal(copyContractors);
            setSavedIdContractor(response?.data?.data?.id);
            // Limpiar campos tras éxito
            setNewContractorName('');
            setItselfRegister(false);
            setNewContractorEmail('');
            setNewContractorNotes('');

            setTimeout(() => {
              setShowCompletedRequesting(false);
            }, 3000);
          } else if (response.data.statusCode === -2) {
            setErrorMessage(
              "El correo que intentas registrar para el contratante ya ha sido utilizado anteriormente, por favor utilice otro correo."
            );
            setShowLoadingRequesting(false);
            setShowErrorRequesting(true);
            setTimeout(() => {
              setShowErrorRequesting(false);
            }, 3000);
          } else if (response.data.statusCode === 440) {
            setErrorMessage(t('requestForContract.error.questionnaireWithoutTemplate'))
            setShowLoadingRequesting(false)
            setShowErrorRequesting(true)
            setTimeout(() => {
              setShowErrorRequesting(false)
            }, 4000)
          } else {
            setShowLoadingRequesting(false);
            setShowErrorRequesting(true);
            setTimeout(() => {
              setShowErrorRequesting(false);
            }, 3000);
          }
        } else {
          setErrorInEmail(true);
          setTimeout(() => {
            setErrorInEmail(false);
          }, 3000);
        }
      } else {
        setErrorInDocumentName(true);
        setTimeout(() => {
          setErrorInDocumentName(false);
        }, 3000);
      }
    } catch (e) {
      setShowLoadingRequesting(false);
      setShowErrorRequesting(true);
      setTimeout(() => {
        setShowErrorRequesting(false);
      }, 3000);
    }
  };

  const deleteContractor = (dataItem) => {
    let contractorsFinalCopy = [...contractorsFinal];
    let contractorsFilteredCopy = [...contractorsFiltered];
    let contractorsStateCopy = [...contractorsState];
    let searchUpdateCopy = [...searchUpdateState];
    let idContractor = contractorsState.findIndex(
      (obj) => obj.id == dataItem.id
    );
    contractorsFinalCopy.splice(
      contractorsFinalCopy.findIndex((a) => a.id === dataItem.id),
      1
    );
    contractorsFilteredCopy.splice(
      contractorsFilteredCopy.findIndex((a) => a.id === dataItem.id),
      1
    );
    contractorsStateCopy[idContractor].isChecked = false;
    searchUpdateCopy[idContractor].isChecked = false;
    setSearchUpdateState(searchUpdateCopy);
    setContractorsFiltered(contractorsFilteredCopy);
    setContractorsFinal(contractorsFinalCopy);
    setShowDialogYesNo(!showDialogYesNo);
  };

  const handleChangeCheckbox = (e, item) => {
    const { checked } = e.target;
    let newState = [...contractorsFiltered];
    let otherNewState = [...contractorsState];
    let forSearch = [...searchUpdateState];
    let idContractorForSearch = forSearch.findIndex((obj) => obj.id == item.id);
    let idContractorForState = otherNewState.findIndex(
      (obj) => obj.id == item.id
    );
    let state = { ...contractorsState.find((obj) => obj.id == item.id) };

    if (checked) {
      state.isChecked = checked;
      newState.push(state);
      forSearch[idContractorForSearch] = state;
      otherNewState[idContractorForState] = state;
    } else {
      state.isChecked = checked;
      newState.splice(
        newState.findIndex((a) => a.id === item.id),
        1
      );
      forSearch[idContractorForSearch] = state;
      otherNewState[idContractorForState] = state;
    }
    setContractorsState([
      ...otherNewState
        .sort((a, b) => Number(b.isChecked) - Number(a.isChecked))
        .filter((contractor) => {
          return contractor.name
            .toLowerCase()
            .includes(searchValue.toLowerCase());
        }),
    ]);
    setSearchUpdateState([...forSearch]);
    setContractorsFiltered([...newState]);
  };

  const handleAddContractors = () => {
    setPreviousFilteredState([...contractorsFiltered]);
    setContractorsPreviousState([...contractorsState]);
    setContractorsFinal([...contractorsFiltered]);
    setDialogForm(!toggleDialogForm);
  };

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  const searchChange = (e) => {
    e.preventDefault();
    setSearchValue(e.target.value);
  };

  useEffect(() => {
    let contractorsCopy = [...searchUpdateState];
    let dataUpdateSearch = contractorsCopy.filter((contractor) => {
      return contractor.name.toLowerCase().includes(searchValue.toLowerCase());
    });
    setContractorsState(
      dataUpdateSearch.sort((a, b) => Number(b.isChecked) - Number(a.isChecked))
    );
  }, [searchValue]);

  const abrirDialog = () => {
    if (!documentRequestName) {
      setErrorMessage(t("digitalContractDashboard.newContract.errorDocumentName"));
      setShowWarningRequesting(true);
      setTimeout(() => {
        setShowWarningRequesting(false);
      }, 3000);
      return;
    }
    setShowLoadingRequesting(true);
    if (toggleNewContractorDialog) {
      setToggleNewContractorDialog(false);
    }
    setContractorsState(
      contractorsState.sort((a, b) => Number(b.isChecked) - Number(a.isChecked))
    );
    setTimeout(() => {
      setShowLoadingRequesting(false);
      setDialogForm(!toggleDialogForm);
    }, 3000);
  };

  const cancelUpload = () => {
    setSearchUpdateState([...previousContractorsState]);
    setContractorsFiltered([...previousFilteredState]);
    setContractorsState([...previousContractorsState]);
    setDialogForm(!toggleDialogForm);
  };

  const closeContractorDialog = () => {
    setToggleNewContractorDialog(false);
  };

  const closeDialog = () => {
    setSearchUpdateState([...previousContractorsState]);
    setContractorsFiltered([...previousFilteredState]);
    setContractorsState([...previousContractorsState]);
    setDialogForm(!toggleDialogForm);
  };

  const toggleDialogYesNo = (dataItem, value) => {
    setDataItemUser(dataItem);
    setShowDialogYesNo(value);
  };

  const toggleLoadingRequesting = () => {
    setShowLoadingRequesting(false);
  };

  const toggleErrorRequesting = () => {
    setShowErrorRequesting(false);
  };

  const toggleCompletedRequesting = () => {
    setShowCompletedRequesting(false);
  };

  const toggleWarningRequesting = () => {
    setShowWarningRequesting(false);
  };

  const handleAddNewContractor = () => {
    setDialogForm(false);
    setToggleNewContractorDialog(true);
  };

  const onChangeCompanyDialog = (e) => {
    let value = e.target.value;
    setCompanySelectedDialog(value);
  };

  return (
    <div className="requestForContract-wrapper">
      {props.loading ? (
        <SimpleLoading />
      ) : (
        <div className="requestForContractPanelView-container">
          <div className="requestForContract-navbar">
            <div className="requestForContract-top-grid">
              <div className="requestForContract-top-left">
                <div className="requestForcontract-questionnaire-name">
                  <p>{`${t("digitalContractDashboard.newContract.solictudeOf")} ${questionnaire && questionnaire.name}`}</p>
                </div>
                <div className="requestForContract-buttonHLPure">
                  <InputHLPure
                    autoFocus
                    typeInput="text"
                    labelInput={t("requestForContract.documentName")}
                    valueInput={documentRequestName}
                    inputActive
                    handleChangeInput={(e) =>
                      handleChangeDocumentRequestName(e)
                    }
                    characterLimit={128}
                  />
                </div>
                {errorInDocumentName ? (
                  <span className="hint-message-error">
                    {t("digitalContractDashboard.newContract.error.enterAValidDocumentName")}
                  </span>
                ) : null}
              </div>
              <div className="requestForContract-top-right">
                {questionnaire &&
                  questionnaire.company &&
                  questionnaire.company.companyName &&
                  questionnaire.companyId &&
                  questionnaire.companyId !== NIL ? (
                  <div className="requestForContractPanelView-related-company">
                    <p className="requestForcontract-paragraphRequest">
                      {t("digitalContractDashboard.newContract.relatedBusiness")}
                    </p>
                    <p className="requestForcontract-company-name">
                      {questionnaire?.company?.companyName}
                    </p>
                  </div>
                ) : (
                  <div className="requestForContractPanelView-related-company">
                    <p className="requestForcontract-paragraphRequest">
                      {t("digitalContractDashboard.newContract.noRelatedBusiness")}
                    </p>
                  </div>
                )}
              </div>
            </div>
            <div className="requestForContractPanelView-contractor-text">
              <span>
                {t("digitalContractDashboard.newContract.contractorDescText")}
              </span>
            </div>
            <div className="requestForContractPanelView-add-contractor">
              <ButtonAddHLPure
                nameBtn={t("digitalContractDashboard.newContract.addContractor")}
                iconAdd
                onClickBtn={() => abrirDialog()}
              />
            </div>
            <GridHLPure
              {...props}
              dataGrid={contractorsFinal}
              skip={0}
              take={6}
              minHeight={1}
              onSelectedItem={setSelectedUser}
              titleRow1={t("digitalContractDashboard.newContract.contractorGrid")}
              fieldRow1={"name"}
              fieldSubtitle={"newUpdatedDate"}
              titleRow4={t("digitalContractDashboard.newContract.actionsGrid")}
              columnFour
              showDialogYesNo
              btnOpenDialog1={toggleDialogYesNo}
              activeDialog1
              setShowDetails={setShowDetails}
              iconOneActive={false}
              labelOneActions={t("ModalDelete.title")}
            />
          </div>
          <div container className="requestForContract-bottomGroupBtn">
            <div className="requestForContract-bottomButtons">
              <ButtonHLPure nameBtn={t("button.cancel")} onClickBtn={() => changeRoute('request-new-contract')} />
            </div>
            <div className="requestForContract-bottomButtons">
              <ButtonHLPure
                nameBtn={t("digitalContractDashboard.newContract.error.startRequest")}
                primary
                onClickBtn={() => {
                  validateContractName();
                }}
              />
            </div>
          </div>

          {toggleDialogForm ? (
            <DialogFormHLPure
              showChildrenBottom
              titleDialog={t("digitalContractDashboard.newContract.addContractorModalTitle")}
              cancel={() => closeDialog()}
              column
              children={
                <Grid container xs={12} lg={12} md={12} sm={12} es={12} className="requestForContract-dialog-body">
                  <div className="requestForContract-searchBar-checkBox">
                    <div className="requestForContract-searchBar">
                      <SearchBarHLPure
                        onSearchChange={(e) => searchChange(e)}
                      />
                    </div>
                    <div className="requestForContract-containerCheckbox">
                      {contractorsState
                        .sort(
                          (a, b) => Number(b.isChecked) - Number(a.isChecked)
                        )
                        .map((item) => {
                          return (
                            <div className="requestForContract-checkBox">
                              <CheckBoxHLPure
                                labelCheckBox={item.name}
                                checkedState={item.isChecked}
                                onChangeHandler={(e) => {
                                  handleChangeCheckbox(e, item);
                                }}
                              />
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </Grid>
              }
              childrenBottom={
                <Grid
                  container
                  xs={12}
                  lg={12}
                  md={12}
                  sm={12}
                  es={12}
                  className="requestForContract-newContracterGrid"
                >
                  <div className="requestForContract-newContracter">
                    <ButtonHLPure
                      nameBtn={t("digitalContractDashboard.newContract.newContractorRegistration")}
                      style={{ marginBottom: 10 }}
                      onClickBtn={() => handleAddNewContractor()}
                    />
                    <ButtonHLPure
                      nameBtn={t("button.cancel")}
                      onClickBtn={() => cancelUpload()}
                      style={{ marginBottom: 10 }}
                    />
                    <ButtonHLPure
                      primary={true}
                      nameBtn={t("digitalContractDashboard.newContract.includeInDocument")}
                      onClickBtn={() => handleAddContractors()}
                    />
                  </div>
                </Grid>
              }
            />
          ) : null}
          {toggleNewContractorDialog ? (
            <DialogContractor
              //Nombre
              labelNameInput={t("digitalContractDashboard.newContract.nameOrCompanyName")}
              stateNameContractor={newContractorName}
              onChangeNameContractor={(e) => setNewContractorName(e.target.value)}
              onErrorNameState={errorInContractorName}
              //Correo
              labelEmailInput={t("digitalContractDashboard.newContract.contractorEmail")}
              stateEmailContractor={newContractorEmail}
              onChangeEmailContractor={handleChangeContractrorEmail}
              myselfRegisterState={itselfRegister}
              onChangeMyselfRegister={(e) => handleItselfRegister(e)}
              //Fecha
              labelDataPicker={t("digitalContractDashboard.newContract.deadlineRegistration")}
              stateDate={newContractLimitDate}
              limitDate={today}
              limitMaxDate={limitMaxDate}
              onChangeDateContractor={handleChangeLimitDate}
              onErrorDateState={toggleErrorInDate}
              //Notas
              stateNotesContractor={newContractorNotes}
              onChangeNotesContractor={handleChangeContractrorNotes}
              //Dropdown
              personTypeLabel={t("digitalContractDashboard.newContract.personType")}
              onTypePersonChange={(e) =>
                setContractorType(Number(e.target.value))
              }
              contractorsTypeOptions={contractorsType}
              valueOptionDropdown={"id"}
              nameOptionDropdown={"value"}
              //Botones y Dialog
              cancelName={t("button.cancel")}
              submitName={t("button.save")}
              titleDialog={t("digitalContractDashboard.newContract.createNewContractor")}
              cancel={() =>
                setToggleNewContractorDialog(!toggleNewContractorDialog)
              }
              handleSubmit={() => createContractor()}
              companies={companies}
              filterChangeCompanies={onChangeCompanyDialog}
              companyFilerSelected={companySelectedDialog}
              showCompanyDrop={true}
            />
          ) : null}
          <DialogSystemGLPure
            showErrorRequesting={showErrorRequesting}
            showLoadingRequesting={showLoadingRequesting}
            showCompletedRequesting={showCompletedRequesting}
            showWarningRequesting={showWarningRequesting}
            toggleLoadingRequesting={toggleLoadingRequesting}
            toggleCompletedRequesting={toggleCompletedRequesting}
            toggleErrorRequesting={toggleErrorRequesting}
            toggleWarningRequesting={toggleWarningRequesting}
            messageWarning={errorMessage}
            messageError={errorMessage}
            showConfirm={showDialogYesNo}
            confirmTitle={t("requestForContract.dialogDeleteDocumenTitle")}
            confirmMessage={t("requestForContract.dialogConfirmDeleteContracter")}
            handleConfirmDeleteFlowClose={() => setShowDialogYesNo(false)}
            handleConfirmDeleteFlowSubmit={() => deleteContractor(dataItemUser)}
            labelCancelConfirmation={t("documentsToRequire.dialogCancelButton")}
            labelSubmitConfirmation={t("documentsToRequire.dialogDeleteDocumentButton")}
          />
        </div>
      )}
    </div>
  );
};

export default RequestForContractPanelView;